import dayjs from "dayjs";
import Tooltip from "../../../DesignSystem/Tooltip/Tooltip";
import { ReactComponent as HistoryIcon } from "../../../../assets/icons/HistoryIcon.svg";
import { ReactComponent as HistoryEventIcon } from "../../../../assets/icons/marketingDashbaord/ProgressHistory.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/information.svg";
import "../../../../css/Marketing/WebsiteCharges.css";

const getHistoryTone = (label = "") => {
  const status = label.toLowerCase();
  if (status.includes("live")) return "green";
  if (status.includes("npw") || status.includes("npm")) return "green";
  if (status.includes("adviser review")) return "purple";
  if (
    status.includes("internal review") ||
    /(^|to )review$/.test(status)
  )
    return "orange-600";
  if (status.includes("branding")) return "orange";
  if (status.includes("content writing") || status.includes("design"))
    return "yellow";
  if (status.includes("on hold") || status.includes("get in contact"))
    return "grey";
  return "blue";
};

const getEventDate = (item) => item.createdAt?.toDate?.() || item.createdAtMs;

const getStatusDuration = (item, items) => {
  const startedAt = getEventDate(item);
  if (!startedAt) return "";

  const startedAtMs = dayjs(startedAt).valueOf();
  const nextChangeMs = items
    .map(getEventDate)
    .filter(Boolean)
    .map((date) => dayjs(date).valueOf())
    .filter((dateMs) => dateMs > startedAtMs)
    .sort((left, right) => left - right)[0];
  const endedAtMs = nextChangeMs || Date.now();
  const days = Math.max(0, Math.ceil((endedAtMs - startedAtMs) / 86400000));
  return `${days} ${days === 1 ? "day" : "days"}`;
};

const ProgressHistory = ({
  items = [],
  loading = false,
  title = "Progress History",
  ariaLabel = "Progress history",
  emptyMessage = "Progress will appear here after the entry is saved.",
  showDuration = true,
  tooltipPosition = "left",
}) => (
  <aside className="website-history" aria-label={ariaLabel}>
    {title && (
      <h3 className="row gap-s FP_Content_Semibold">
        <HistoryIcon aria-hidden /> {title}
      </h3>
    )}
    {loading ? (
      <p className="website-muted FP_Help_Text">Loading history…</p>
    ) : items.length ? (
      <ol className="website-history__list">
        {items.map((item) => {
          const date = getEventDate(item);
          const tone = item.tone || getHistoryTone(item.label);
          const changedBy = item.userDisplayName || item.userEmail;
          const duration = showDuration ? getStatusDuration(item, items) : "";
          const notes = String(item.notes || "").trim();
          const description = String(item.description || "").trim();
          return (
            <li key={item.id}>
              <span
                className={`website-history__marker website-history__marker--${tone}`}
              >
                <HistoryEventIcon aria-hidden />
              </span>
              <div>
                <div className="row-wrap align-start text-align-left gap-s FP_Help_Text_Semibold">
                  <span className="inline-flex flex-wrap align-start text-align-left gap-s FP_Help_Text black">
                    {item.label}
                    {duration && " | "}
                    {duration && duration}
                    {notes && (
                      <Tooltip content={notes} position={tooltipPosition}>
                        <InfoIcon
                          className="website-history__notes-icon"
                          // aria-label={`Notes for ${item.label}`}
                        />
                      </Tooltip>
                    )}
                  </span>
                </div>
                <small className="FP_Help_Text">
                  {date ? dayjs(date).format("DD MMM YY | HH:mm") : ""}
                  {changedBy ? ` | ${changedBy}` : ""}
                </small>
                {description ? (
                  <p className="website-history__description FP_Help_Text">
                    {description}
                  </p>
                ) : null}
              </div>
            </li>
          );
        })}
      </ol>
    ) : (
      <p className="website-muted FP_Help_Text">{emptyMessage}</p>
    )}
  </aside>
);

export default ProgressHistory;
